export default [
    {
        titulo: 'Permisos',
        path: '/administracion/configuracion/permisos',
        name: 'administracion-configuracion-permisos',
        component: () =>
            import ('@/views/pages/administracion/configuracion/Permisos.vue'),
        meta: {
			title: 'i18n:Permisos',
            resource: 'Administracion',
            action: 'ver-administracion-configuracion-permisos',
        },
    },
    {
        title: 'Autorizaciones',
        path: '/administracion/configuracion/autorizaciones',
        name: 'administracion-configuracion-autorizaciones',
        component: () =>
            import ('@/views/pages/administracion/configuracion/Autorizaciones.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Administracion',
            action: 'ver-administracion-configuracion-permisos',
        },
    },
    {
        title: 'Mantenimiento',
        path: '/administracion/mantenimiento',
        name: 'administracion-mantenimiento',
        component: () =>
            import ('@/views/pages/administracion/mantenimiento/MantenimientoTabs.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Administracion',
            action: 'ver-administracion-mantenimiento',
        },
    },
    {
        title: 'Aprobaciones',
        path: '/administracion/transacciones/aprobaciones',
        name: 'administracion-transacciones-aprobaciones',
        component: () =>
            import ('@/views/pages/administracion/transacciones/Aprobaciones.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Administracion',
            action: 'ver-administracion-transacciones-aprobaciones',
        },
    },
]
